import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrainingService } from './training.service';
import { TrainWizardComponent } from './train-wizard/train-wizard.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [TrainWizardComponent],
    imports: [CommonModule, TranslateModule, FormsModule, SharedModule],
    providers: [TrainingService],
})
export class TrainingModule {}
